export default __webpack_public_path__ + "static/nft1-a5632a08cb3d58d384ddb299d3fabd6e.png";